{
  "1:1 Training Session": "1:1 Training Session",
  "1:1 Training sessions are included in your Bundle. Get the most out of Weave by scheduling now!": "1:1 Training sessions are included in your Bundle. Get the most out of Weave by scheduling now!",
  "All of your locations are eligible for training. Schedule your 1:1 training now!": "All of your locations are eligible for training. Schedule your 1:1 training now!",
  "An error occurred while marking task as complete.": "An error occurred while marking task as complete.",
  "Back": "Back",
  "Confirm Locations": "Confirm Locations",
  "I changed my mind": "I changed my mind",
  "If you were not redirected to a scheduling page click <2>here</2>": "If you were not redirected to a scheduling page click <2>here</2>",
  "No, I Didn't Schedule It": "No, I Didn't Schedule It",
  "Please confirm locations you'd like to include in your training session.": "Please confirm locations you'd like to include in your training session.",
  "Please select a reason.": "Please select a reason.",
  "Schedule 1:1 Training": "Schedule 1:1 Training",
  "Schedule Training": "Schedule Training",
  "Schedule Training for Multiple Locations": "Schedule Training for Multiple Locations",
  "Select Locations": "Select Locations",
  "Select locations": "Select locations",
  "Something went wrong": "Something went wrong",
  "Submit": "Submit",
  "Task completed successfully.": "Task completed successfully.",
  "There were no times when I was available": "There were no times when I was available",
  "Were you able to schedule your training?": "Were you able to schedule your training?",
  "Why were you not able to schedule?": "Why were you not able to schedule?",
  "Yes, I Scheduled It": "Yes, I Scheduled It",
  "{{count}} of your locations are eligible for training. Schedule your 1:1 training now!_one": "{{count}} of your locations are eligible for training. Schedule your 1:1 training now!",
  "{{count}} of your locations are eligible for training. Schedule your 1:1 training now!_other": "{{count}} of your locations are eligible for training. Schedule your 1:1 training now!"
}
